import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Row, Col } from "reactstrap";
import { EnableDeviceSwap, ResetOrderConsumable, ResetSwapDevice, UpdateOrderConsumables } from "../../../../../actions/CSAgentPortal/CustomerDashboard";
import EcoProButton from "../../../../shared/button/button";
import EcoProOverlayModal from "../../../../shared/modal/OverlayModal/EcoProOverlayModal";
import './Overview.css';
import Loader from "../../../../shared/loader/Loader";
import { ORDER_PARTS_CONSUMABLES } from "../../../../../constants/AppConstants";
import EcoproAlert from "../../../../shared/alert/alert";
import AlertDanger from '../../../../../assets/images/alert-danger.svg'
import { printerTypes } from "../../../../../constants/PrinterTypes";
import { currentUserRolesArr, getSupplyOrderConsumables } from "../../../../../constants/AppMethod";
import { canAccess_SwapDevice_OrderSupplies } from "../../../../../constants/UserRoles";

const Overview = (props) => {
    const { t } = useTranslation("CSAgenttranslation");
    const { fetchCSAgentTabContents } = props;
    const dispatch = useDispatch();
    const NOT_AVAILABLE = 'N/A';
    const [modalState, setModalState] = useState(false);
    const [modalProps, setModalProps] = useState({
        modal_title: "",
        modal_sub_title: "",
        modal_content: "",
        cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
        confirm_btn_text: t("MODAL_BUTTON_TXT.CONFIRM"),
        toggleModal: "",
        customClassName: "",
        confirm_btn_onClick: "",
        type: "normal"
    })
    const [orderSuppliesState, setOrderSuppliesState] = useState(null);
    const [swapDeviceState, setSwapDeviceState] = useState(null);
    const [isOrderAlertOpen, setOrderAlertOpen] = useState(true);
    const [counter, setCounter] = useState({})
    const swapDeviceRes = useSelector(state => state.CSAGENT.EnableDeviceSwap);
    const orderConsumablesRes = useSelector(state => state.CSAGENT.UpdateOrderConsumables)
    const DEVICE_AND_USAGE_DETAILS = "device_and_usage_details";

    // get user id
    const userId = props?.userData?.userId;

    //device current usage info
    const planPages = props?.deviceData?.currentUsage?.planPages || 0;
    const planPagesLeft = props?.deviceData?.currentUsage?.printedPlanPages || 0;
    const rollOverPages = props?.deviceData?.currentUsage?.givenRolloverPages || 0;
    const printedRolloverPages = props?.deviceData?.currentUsage?.printedRolloverPages || 0;
    const overagePages = props?.deviceData?.currentUsage?.purchasedOveragePages || 0;
    const printedOveragePages = props?.deviceData?.currentUsage?.printedOveragePages || 0;

    //device info
    const deviceId = props?.deviceData?.deviceId;
    const deviceModel = props?.deviceData?.modelNumber || NOT_AVAILABLE;
    const deviceSerialNumber = props?.deviceData?.serialNumber || NOT_AVAILABLE;
    const printerType = props?.deviceData?.printerType;
    const isSwapEligible = props?.deviceData?.isSwapEnabled;

    //userData
    const sapBpId = props?.userData?.businessPartnerId;
    const countryCode = props?.userData?.countryCode;

    //device associated subscription status
    const deviceSubscriptionStatus = props?.deviceData?.subscriptionStatus || null;

    const cancelSwapBtnStatus = swapDeviceRes?.device_swap_status;
    const INACTIVE = 'INACTIVE';
    const currentuserRoles = currentUserRolesArr();
    const CAN_ACCESS_SWAPDEVICE_ORDERSUPPLIES = canAccess_SwapDevice_OrderSupplies(currentuserRoles);
    const supplyOrderConsumables = getSupplyOrderConsumables(printerType);

    useEffect(() => {
        setOrderAlertOpen(false);
    }, [props?.deviceData]);

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    }
    const toggleModal = (event) => {
        setCounter({})
        setModalState(modalState);
    }
    const swapDevice = (type) => {
        scrollToTop();
        setModalState(false);
        let swap_status = type === "swap" ? true : false;
        setSwapDeviceState(true);
        dispatch(EnableDeviceSwap(userId, deviceId, swap_status, isSwapEligible));
    }

    const handleSwapDevice = (type) => {
        dismissOrderAlert();
        setModalState(true);
        dispatch(ResetSwapDevice());
        dispatch(ResetOrderConsumable());
        setOrderAlertOpen(true);
        let modal_title = type === "swap" ? t("CUSTOMER_DASHBOARD.OVERVIEW.SWAP_MODAL_TITLE") : t("CUSTOMER_DASHBOARD.OVERVIEW.CANCEL_SWAP_MODAL_TITLE")
        let modal_content = type === "swap" ? t("CUSTOMER_DASHBOARD.OVERVIEW.SWAP_MODAL_CONTENT") : t("CUSTOMER_DASHBOARD.OVERVIEW.CANCEL_SWAP_MODAL_CONTENT")
        setModalProps({
            modal_state: modalState,
            modal_title: modal_title,
            modal_content: modal_content,
            cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
            confirm_btn_text: t("MODAL_BUTTON_TXT.CONFIRM"),
            toggleModal: toggleModal,
            customClassName: "customer-dashboard-swap-modal",
            confirm_btn_onClick: () => swapDevice(type),
            type: "normal"
        })
    }
    const incrementCounter = (e) => {
        const valuecounter = (counter[e.target.name]) ? counter[e.target.name] + 1 : 0 + 1;
        setCounter({ ...counter, [e.target.name]: valuecounter });
    }
    const decrementCounter = (e) => {
        const valuecounter = (counter[e.target.name]) ? counter[e.target.name] - 1 : 0;
        setCounter({ ...counter, [e.target.name]: valuecounter });
    }

    /* Comment: Below handleOrderParts func is being used by 'Order Parts' button which has been commented for now, 
    but maye be utilized in future. do not delete this function code */
    // eslint-disable-next-line
    const handleOrderParts = () => {
        dismissOrderAlert();
        setModalState(true);
        dispatch(ResetOrderConsumable());
        dispatch(ResetSwapDevice());
        setOrderAlertOpen(true);
        setModalProps({
            modal_type: "order_parts",
            modal_title: `${t("CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.ORDER_PARTS")} - ${deviceModel}`,
            modal_sub_title: t("CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.ORDER_PARTS_SUBITITLE"),
            modal_content: ORDER_PARTS_CONSUMABLES,
            cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
            confirm_btn_text: t("CUSTOMER_DASHBOARD.OVERVIEW.CONFIRM_ORDER"),
            toggleModal: toggleModal,
            customClassName: "customer-dashboard-order-parts-modal",
            confirm_btn_onClick: triggerOrderPartsApiCall,
            type: "quantity",
            modal_table_title: t("CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.PART_NAME"),
            modal_table_quantity: t("CUSTOMER_DASHBOARD.OVERVIEW.QUANTITY")
        });
    }

    const handleOrderSupplies = () => {
        dismissOrderAlert();
        setModalState(true);
        dispatch(ResetOrderConsumable());
        dispatch(ResetSwapDevice());
        setOrderAlertOpen(true);
        setModalProps({
            modal_type: "order_supplies",
            modal_title: t("CUSTOMER_DASHBOARD.OVERVIEW.SUPPLIES_ORDER_HISTORY.ORDER_SUPPLIES"),
            modal_sub_title: t("CUSTOMER_DASHBOARD.OVERVIEW.SUPPLIES_ORDER_HISTORY.SELECT_SUBTITLE"),
            modal_content: supplyOrderConsumables,
            cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
            confirm_btn_text: t("CUSTOMER_DASHBOARD.OVERVIEW.CONFIRM_ORDER"),
            toggleModal: toggleModal,
            customClassName: "customer-dashboard-order-parts-modal",
            confirm_btn_onClick: triggerOrderPartsApiCall,
            type: "quantity",
            modal_table_title: t("CUSTOMER_DASHBOARD.OVERVIEW.SUPPLIES_ORDER_HISTORY.SUPPLY_TYPE"),
            modal_table_quantity: t("CUSTOMER_DASHBOARD.OVERVIEW.QUANTITY")
        });
    }
    const triggerOrderPartsApiCall = (type, data) => {
        scrollToTop();
        setModalState(false);
        let consumablePayload = []
        Object.keys(data).map(key => {
            for (let i = 1; i <= data[key]; i++)
                consumablePayload.push(key)
            return data
        })
        setOrderSuppliesState(true)
        setCounter({})
        dispatch(UpdateOrderConsumables(userId, deviceId, consumablePayload, deviceSerialNumber, sapBpId, countryCode))
    }

    const modalClose = () => {
        setModalState(false);
        dispatch(ResetOrderConsumable());
        dispatch(ResetSwapDevice());

        // call Device&Usage tab again after swspping or roder parts for a device, 
        // to make sure we will get latest data from backend API
        fetchCSAgentTabContents(DEVICE_AND_USAGE_DETAILS);
    }

    if (props?.cancelOrderResponse?.success) {
        setModalState(true);
        setModalProps({
            modal_title: t("CONFIRM_CANCELLATION.CANCELLATION_SUCCESS_MODAL_TITLE"),
            modal_content: t("CONFIRM_CANCELLATION.CANCELLATION_SUCCESS_MODAL_CONTENT"),
            confirm_btn_text: t("MODAL_BUTTON_TXT.CLOSE"),
            customClassName: "customer-dashboard-swap-modal",
            confirm_btn_onClick: modalClose,
            type: "normal",
        });
    }

    if (swapDeviceRes?.success && swapDeviceState) {
        const content = (swapDeviceRes.swap_status_requested) ? t("CUSTOMER_DASHBOARD.OVERVIEW.SWAP_DEVICE.ENABLE_SWAP_CONFIRMED_CONTENT") : t("CUSTOMER_DASHBOARD.OVERVIEW.SWAP_DEVICE.DISABLE_SWAP_CONFIRMED_CONTENT");
        setModalState(true);
        setModalProps({
            modal_title: t("CUSTOMER_DASHBOARD.OVERVIEW.SWAP_DEVICE.REQUEST_CONFIRMED"),
            modal_content: content,
            confirm_btn_text: t("MODAL_BUTTON_TXT.CLOSE"),
            customClassName: "customer-dashboard-swap-modal",
            confirm_btn_onClick: modalClose,
            type: "normal",
        });
        setSwapDeviceState(false);
    }

    if (orderConsumablesRes?.success && orderSuppliesState) {
        setModalState(true);
        setModalProps({
            modal_title: t("CUSTOMER_DASHBOARD.OVERVIEW.SUPPLIES_ORDER_HISTORY.ORDER_CONFIRMED"),
            modal_content: t("CUSTOMER_DASHBOARD.OVERVIEW.SUPPLIES_ORDER_HISTORY.ORDER_CONFIRMED_CONTENT"),
            confirm_btn_text: t("MODAL_BUTTON_TXT.CLOSE"),
            customClassName: "customer-dashboard-swap-modal",
            confirm_btn_onClick: modalClose,
            type: "normal",
        });
        setOrderSuppliesState(false)
    }

    const dismissOrderAlert = () => {
        setOrderAlertOpen(false);
    }

    return (
        <div className="overview-container mt-40">
            {
                (orderConsumablesRes.loading
                    || swapDeviceRes.loading
                    || props?.cancelOrderResponse?.loading) && <Loader setOverlay={true}></Loader>

            }
            {
                (props?.cancelOrderResponse?.error) &&
                <EcoproAlert
                    alertImg={AlertDanger}
                    dismissAlert={dismissOrderAlert}
                    alertSubHeader={props.cancelOrderResponse.error}
                ></EcoproAlert>
            }
            {
                (orderConsumablesRes.error) && isOrderAlertOpen &&
                <EcoproAlert
                    alertImg={AlertDanger}
                    dismissAlert={dismissOrderAlert}
                    alertSubHeader={t('CUSTOMER_DASHBOARD.OVERVIEW.PLAN_INFORMATION.SUPPLY_ORDER_ERROR', { error_message: orderConsumablesRes.error })}
                ></EcoproAlert>
            }
            {
                (swapDeviceRes.error) && isOrderAlertOpen &&
                <EcoproAlert
                    alertImg={AlertDanger}
                    dismissAlert={dismissOrderAlert}
                    alertSubHeader={t('CUSTOMER_DASHBOARD.OVERVIEW.PLAN_INFORMATION.SWAP_DEVICE_ERROR', { error_message: swapDeviceRes.error })}
                ></EcoproAlert>
            }
            {
                deviceSubscriptionStatus && deviceSubscriptionStatus.indexOf(INACTIVE) > -1 &&
                <EcoproAlert
                    alertClass="dashboard-info"
                    alertSubHeader={t('CUSTOMER_DASHBOARD.OVERVIEW.INACTIVE_INFO', { serial_number: deviceSubscriptionStatus?.split(":")[1].replace(")", "").trim() })}
                    showAlertDismiss={false}
                ></EcoproAlert>

            }
            <div>
                <div className="header">
                    <div className="title">
                        <h1>{t('CUSTOMER_DASHBOARD.OVERVIEW.PLAN_INFORMATION.TITLE')}</h1>
                    </div>
                </div>
                <Row className="device-page-info-wrapper">
                    <Col className="blocks move-left">
                        <div className="block-title">
                            <h5>{t('CUSTOMER_DASHBOARD.OVERVIEW.PLAN_INFORMATION.PAGES_USED')}</h5>
                        </div>
                        <div className="block-content">
                            <p><span>{planPagesLeft}</span> /{planPages}</p>
                        </div>
                    </Col>
                    <Col className="blocks move-left">
                        <div className="block-title">
                            <h5>{t('CUSTOMER_DASHBOARD.OVERVIEW.PLAN_INFORMATION.ROLLOVER')}</h5>
                        </div>
                        <div className="block-content">
                            <p><span>{printedRolloverPages}</span> /{rollOverPages}</p>
                        </div>
                    </Col>
                    <Col className="blocks move-left">
                        <div className="block-title">
                            <h5>{t('CUSTOMER_DASHBOARD.OVERVIEW.PLAN_INFORMATION.OVERAGES')}</h5>
                        </div>
                        <div className="block-content">
                            <p><span>{printedOveragePages}</span> /{overagePages}</p>
                        </div>
                    </Col>
                </Row>
                <div className="device-details-wrapper mt-40">
                    <div className="header">
                        <div className="title">
                            <h1>{t('CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.TITLE')}</h1>
                        </div>
                    </div>
                    <div className="device-details-info mt-15">
                        <p>{t('CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.MODEL_NUMBER')}: <span>{deviceModel}</span></p>
                        <p>{t('CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.SERIAL_NUMBER')}: <span>{deviceSerialNumber}</span></p>
                        <p>{t('CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.DEVICE_TYPE')}: <span>{printerType}</span></p>
                    </div>
                    {CAN_ACCESS_SWAPDEVICE_ORDERSUPPLIES && <div className="device-details-btn-wrapper">
                        {
                            cancelSwapBtnStatus && !isSwapEligible &&
                            <EcoProButton cname="default white-bg-btn" onBtnClick={() => handleSwapDevice("cancel-swap")}>{t('CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.CANCEL_DEVICE_SWAP')}</EcoProButton>
                        }
                        {
                            !cancelSwapBtnStatus && !isSwapEligible &&
                            <EcoProButton cname="default" onBtnClick={() => handleSwapDevice("swap")}>{t('CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.SWAP_DEVICE')}</EcoProButton>

                        }
                        {
                            cancelSwapBtnStatus && isSwapEligible &&
                            <EcoProButton cname="default" onBtnClick={() => handleSwapDevice("swap")}>{t('CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.SWAP_DEVICE')}</EcoProButton>

                        }
                        {
                            !cancelSwapBtnStatus && isSwapEligible &&
                            <EcoProButton cname="default white-bg-btn" onBtnClick={() => handleSwapDevice("cancel-swap")}>{t('CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.CANCEL_DEVICE_SWAP')}</EcoProButton>
                        }
                        {
                            printerType === printerTypes.INKJET ?
                                null
                                :
                                <EcoProButton cname="default" onBtnClick={(event) => handleOrderParts(event)}>{t('CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.ORDER_PARTS')}</EcoProButton>
                        }
                    </div>}
                </div>
                <div className="cs-agent order-history-section device-details-wrapper mt-40">
                    <div className="header">
                        <div className="title">
                            <h1>{t("CUSTOMER_DASHBOARD.OVERVIEW.SUPPLIES_ORDER_HISTORY.SUPPLIES_ORDER_HISTORY")}</h1>
                        </div>
                    </div>
                    {CAN_ACCESS_SWAPDEVICE_ORDERSUPPLIES && <div className="device-details-btn-wrapper mt-10 mb-60">
                        <EcoProButton cname="default" onBtnClick={(event) => handleOrderSupplies(event)}>{t('CUSTOMER_DASHBOARD.OVERVIEW.SUPPLIES_ORDER_HISTORY.ORDER_SUPPLIES')}</EcoProButton>
                    </div>}
                </div>
                <EcoProOverlayModal
                    {...modalProps}
                    modal_state={modalState}
                    incrementCounter={incrementCounter}
                    decrementCounter={decrementCounter}
                    counter={counter}
                ></EcoProOverlayModal>
            </div>
        </div>
    )
}

export default Overview;
